import { ArrowRightCircle } from 'react-bootstrap-icons';

export const ConnectBtn = () => {
    return <button onClick={() => console.log(`let's connect!`)}>Let’s Connect <ArrowRightCircle size={25} /></button>
}